import React from 'react';
import { titleMRClass } from "src/components/common/common";

interface SwitchButtonFormProps {
  title?: string;
  value: 'Y' | 'N';
  onChange: (name: string, newValue: 'Y' | 'N') => void;
  name: string;
  editable?: boolean;
  titleless?: boolean;
  wrapperOption?: {
    wrapperStyle?: string;
    titleStyle?: string;
    inputStyle?: string;
  };
}

export const SwitchButtonForm: React.FC<SwitchButtonFormProps> = ({
  title,
  value,
  onChange,
  name,
  editable = true,
  titleless = false,
  wrapperOption = {
    wrapperStyle: "w-[150px] min-w-[150px] mr-[10px] mb-[5px]",
    titleStyle: "w-[150px] min-w-[150px]",
    inputStyle: "w-[100px] min-w-[100px]"
  },
}) => {
//   const isYes = value === 'Y';

  const handleToggle = () => {
    if (editable) {
      onChange(name, value === 'Y' ? 'N' : 'Y');
    }
  };

  return (
    <div className={`flex items-center h-[24px] ${wrapperOption.wrapperStyle}`}>
      <p className={`${wrapperOption.titleStyle} form-title ${titleMRClass} ${titleless ? 'hidden' : ''}`}>
        {title}
      </p>
      <div
        className={`flex items-center ${wrapperOption.inputStyle} h-full`}
        onClick={handleToggle}
      >
		{/* value : {value} */}
        <div
            className={`relative flex items-center w-12 h-5 rounded-[10px] transition-colors duration-300
						border-[1px] border-gray-300
						${editable
                            ? (value === 'Y' ? 'bg-blue-light' : 'bg-gray-0') + ' cursor-pointer'
                            : 'bg-gray-100 cursor-not-allowed'
                        }`
					}
        >
            <div
                className={`absolute w-4 h-3 bg-transparent rounded-full shadow-md transform transition-transform duration-200 ease-in-out 
				${
					// value === 'Y' ? 'translate-x-[26px]' : 'translate-x-1'
					value === 'Y' ? 'translate-x-1' : 'translate-x-[26px]'

				}`}
            />
            <span className={`absolute left-2 text-xs font-semibold ${value === 'Y' ? 'text-black ' : 'text-gray-200'}`}>
                Y
            </span>
            <span className={`absolute right-2 text-xs font-semibold ${value === 'Y' ? 'text-gray-200' : 'text-gray-500'}`}>
                N
            </span>
        </div>
      </div>
    </div>
  );
};